import feed from "domains/resources/covers/content_panel_thumbnail.jpg";
import tms_1 from "domains/resources/covers/create_thumbnail.jpg";
import discover from "domains/resources/covers/discover_thumbnail.jpg";
import fullscreen from "domains/resources/covers/full_screen_mode_thumbnail.jpg";
import brief from "domains/resources/covers/intelligence_briefings_thumbnail.jpg";
import languages from "domains/resources/covers/languages_thumbnail.jpg";
import monitor from "domains/resources/covers/monitor_thumbnail.jpg";
import sharing from "domains/resources/covers/sharing_maps_thumbnail.jpg";
import tms_2 from "domains/resources/covers/smart_map_assistant_thumbnail.jpg";
import introduction from "domains/resources/covers/strategic_intelligence_introduction_thumbnail.png";
import themes from "domains/resources/covers/themes_thumbnail.jpg";
import tms from "domains/resources/covers/transformation_maps_thumbnail.jpg";

export const covers = {
  brief,
  discover,
  feed,
  fullscreen,
  introduction,
  languages,
  monitor,
  sharing,
  themes,
  tms_1,
  tms_2,
  tms,
};
